export default "__VITE_ASSET__BCTnFHre__"